/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { Col, Modal, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import TranslateText from "../../TranslateText";
import { storeProductSelector } from "../../../../services/selector/index.";
import "../../../../assets/style/modalStyle/detailProduct.scss";
import { useEffect } from "react";
import { setOpenDetailProduct } from "../../../../services/slice/StoreSlice";
import LabelInput from "../../LabelInput";
import { setOpenDetailChatBkavPro } from "../../../../services/slice/ChatBkavProSlice";
const ModalDetailChatBkavPro = ({ title }) => {
  const dispatch = useDispatch();

  const handCancel = () => {
    dispatch(setOpenDetailChatBkavPro({ isOpen: false, id: "" }));
  };
  const longText = `Bkav trân trọng kính chúc Quý khách hàng một năm mới 2025 An Khang Thịnh Vượng, Vạn Sự Như Ý! 
  Cảm ơn Quý khách đã tin tưởng và đồng hành cùng Bkav trong suốt thời gian qua. 
  Bkav trân trọng kính chúc Quý khách hàng một năm mới 2025 An Khang Thịnh Vượng, Vạn Sự Như Ý! 
  Cảm ơn Quý khách đã tin tưởng và đồng hành cùng Bkav trong suốt thời gian qua.`;
  return (
    <>
      <Modal
        // className="wrapperDetailChatBkavPro"
        title={<TranslateText text={title} />}
        centered
        width={1000}
        open={false}
        onCancel={handCancel}
        footer={[]}
      >
        <Row style={{ display: "flex" }}>
          <Col span={5}>
            {" "}
            <LabelInput text={"Tên tin nhắn"} style={{ textAlign: "start" }} />
          </Col>
          <Col span={18}>Chúc mừng năm mới 2025</Col>
        </Row>
        <Row
          style={{ display: "flex", marginTop: "32px", marginBottom: "8px" }}
        >
          <Col span={5}>
            {" "}
            <LabelInput
              text={"Nội dung tin nhắn"}
              style={{ textAlign: "start" }}
            />
          </Col>
          <Col span={18}>
            <TextInput text={longText}></TextInput>
          </Col>
        </Row>
        <Row style={{ display: "flex", marginBottom: "8px" }}>
          <Col span={5}>
            {" "}
            <LabelInput text={"Ngày bắt đầu"} style={{ textAlign: "start" }} />
          </Col>
          <Col span={18}>
            <TextInput text={"01/01/2025 08:00"}></TextInput>
          </Col>
        </Row>
        <Row style={{ display: "flex", marginBottom: "8px" }}>
          <Col span={5}>
            {" "}
            <LabelInput text={"Ngày kết thúc"} style={{ textAlign: "start" }} />
          </Col>
          <Col span={18}>
            <TextInput text={"01/01/2025 08:00"}></TextInput>
          </Col>
        </Row>
        <Row style={{ display: "flex", marginBottom: "8px" }}>
          <Col span={5}>
            {" "}
            <LabelInput text={"Ngày tạo"} style={{ textAlign: "start" }} />
          </Col>
          <Col span={18}>
            <TextInput text={"01/01/2025 08:00"}></TextInput>
          </Col>
        </Row>
        <Row style={{ display: "flex", marginBottom: "8px" }}>
          <Col span={5}>
            {" "}
            <LabelInput
              text={"Đối tượng hiển thị"}
              style={{ textAlign: "start" }}
            />
          </Col>
          <Col span={18}>
            <TextInput text={"Toàn bộ KH"}></TextInput>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ModalDetailChatBkavPro;

export const TextInput = ({ text, style }) => {
  return (
    <span
      style={{
        display: "block",
        width: "100%",
        textAlign: "start",
        fontWeight: 400,
        fontFamily: "Roboto",
        fontSize: "14px",
        ...style,
      }}
    >
      <TranslateText text={text} />
    </span>
  );
};
